import React from 'react';
import { Mail, Phone } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-primary text-white/80 py-10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8">
          <div className="flex items-center mb-6 md:mb-0">
            <img src="/logo.png" alt="Logo Lidiane Almeida" className="h-10 w-auto mr-2" />
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="#" className="text-white hover:text-accent transition-colors duration-300 flex items-center">
              <Mail size={16} className="mr-2" />
              contato@lidianealmeidaadv.com
            </a>
            <a href="#" className="text-white hover:text-accent transition-colors duration-300 flex items-center">
              <Phone size={16} className="mr-2" />
              (81) 99350-7689
            </a>
          </div>
        </div>
        
        <div className="border-t border-white/20 pt-6 mt-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h4 className="font-heading font-semibold text-white mb-4">Sobre</h4>
              <p className="text-sm">
                Escritório especializado em Direito Bancário, com foco em desbloqueio de contas e recuperação de valores, além de atuação estratégica em Direito e Processo do Trabalho.
              </p>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-white mb-4">Links Rápidos</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-sm hover:text-accent transition-colors duration-300">Início</a></li>
                <li><a href="#faq" className="text-sm hover:text-accent transition-colors duration-300">Dúvidas Frequentes</a></li>
                <li><a href="#about" className="text-sm hover:text-accent transition-colors duration-300">Sobre Nós</a></li>
                <li><a href="#contact-form" className="text-sm hover:text-accent transition-colors duration-300">Contato</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-white mb-4">Advogada Responsável</h4>
              <ul className="text-sm space-y-1">
                <li><span className="font-semibold">Dra. Lidiane Almeida</span></li>
                <li>OAB: 56.912</li>
                <li>Telefone: <a href="tel:5581993507689" className="hover:text-accent transition-colors">(81) 99350-7689</a></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="text-center text-sm text-white/60 mt-8 pt-6 border-t border-white/10">
          <p> {currentYear} Lidiane Almeida Advocacia. Todos os direitos reservados.</p>
          <p className="mt-2">OAB 56.912</p>
          <p className="mt-2">
            Desenvolvido por <a
              href="https://wa.me/5562999930796?text=Ol%C3%A1.%20Vi%20o%20site%20da%20Dra.%20Lidiane.%20Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20seus%20sistemas."
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent underline hover:text-accent/80 transition-colors"
            >
              Nsistemas
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;